export enum TripState {
    PENDING = 'pending',
    NORMAL = 'normal',
    DELAYED = 'delayed',
    TOO_DELAYED = 'tooDelayed',
    FINISHED = 'finished',
}
